/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { EtlConf } from '../model/etlConf';
import { GetSmtpTemplateOverviewDTO } from '../model/getSmtpTemplateOverviewDTO';
import { TransactionalEmailConfDTO } from '../model/transactionalEmailConfDTO';
import { TransactionalEmailEditorDTO } from '../model/transactionalEmailEditorDTO';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { Pageable } from '../model/pageable';


@Injectable()
export class ConfiguratorTransactionalEmailService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Crée une nouvelle configuration de mail
     * Cette requête permet de créer une nouvelle configuration de mail.&lt;br&gt;Les données de la configuration de mail sont envoyées dans le corps de la requête.&lt;br&gt;Si la requête est correcte, la réponse contient l&#39;URL de la nouvelle configuration de mail en header Location, le DTO de la nouvelle configuration de mail en corps de la réponse et le code HTTP 201 (Created) est renvoyé.&lt;br&gt;Si le DTO fourni a déjà un identifiant, le code d&#39;erreur 400 (Bad Request) est renvoyé.&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param transactionalEmailDTO transactionalEmailDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTransactionalEmailUsingPOST(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe?: 'body', reportProgress?: boolean): Observable<TransactionalEmailConfDTO>;
    public createTransactionalEmailUsingPOST(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionalEmailConfDTO>>;
    public createTransactionalEmailUsingPOST(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionalEmailConfDTO>>;
    public createTransactionalEmailUsingPOST(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createTransactionalEmailUsingPOST.');
        }

        if (transactionalEmailDTO === null || transactionalEmailDTO === undefined) {
            throw new Error('Required parameter transactionalEmailDTO was null or undefined when calling createTransactionalEmailUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TransactionalEmailConfDTO>(`${this.basePath}/api/transactional-email`,
            transactionalEmailDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprime une configuration de mail par identifiant
     * Cette requête permet de supprimer une configuration de mail par identifiant.&lt;br&gt;En cas de succès, la réponse contient le code HTTP 204 (NO_CONTENT) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTransactionalEmailUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTransactionalEmailUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTransactionalEmailUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTransactionalEmailUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteTransactionalEmailUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTransactionalEmailUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère la liste des configurations de mail par tenant
     * Cette requête permet de récupérer la liste des configurations de mail par tenant.&lt;br&gt;En cas de succès, la réponse contient la liste des configurations de mail en corps de la réponse et le code HTTP 200 (OK) est renvoyé.&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTransactionalEmailsUsingGET1(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionalEmailConfDTO>>;
    public getAllTransactionalEmailsUsingGET1(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionalEmailConfDTO>>>;
    public getAllTransactionalEmailsUsingGET1(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionalEmailConfDTO>>>;
    public getAllTransactionalEmailsUsingGET1(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, search?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTransactionalEmailsUsingGET1.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TransactionalEmailConfDTO>>(`${this.basePath}/api/transactional-email`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère la liste des configurations de mail d&#x27;un partenaire
    * Cette requête permet de récupérer la liste des configurations de mail du partenaire.&lt;br&gt;En cas de succès, la réponse contient la liste des configurations de mail en corps de la réponse et le code HTTP 200 (OK) est renvoyé.&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; le paramètre &#x27;X_DATASTORE_ID&#x27; est le code qui correspond au datastore/tenant.
     * @param xDataStoreID
     * @param partner
     * @param pageable
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public getAllTransactionalEmailsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionalEmailConfDTO>>;
    public getAllTransactionalEmailsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionalEmailConfDTO>>>;
    public getAllTransactionalEmailsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionalEmailConfDTO>>>;
    public getAllTransactionalEmailsByPartner(xDataStoreID: string, partner: string, pageable: Pageable, search?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTransactionalEmailsByPartner.');
        }

        if (partner === null || partner === undefined) {
            throw new Error('Required parameter partner was null or undefined when calling getAllTransactionalEmailsByPartner.');
        }

        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getAllTransactionalEmailsByPartner.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', <any>partner);
        }
        if (pageable !== undefined && pageable !== null) {
            // l'API attend page / size / sort, pas un objet « pageable »
            if (pageable.page !== undefined && pageable.page !== null) {
                queryParameters = queryParameters.set('page', <any>pageable.page);
            }
            if (pageable.size !== undefined && pageable.size !== null) {
                queryParameters = queryParameters.set('size', <any>pageable.size);
            }
            if (pageable.sort?.length) {
                queryParameters = queryParameters.set('sort', pageable.sort.join(','));
            }
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TransactionalEmailConfDTO>>('get', `${this.basePath}/api/transactional-email/partner`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère les données pour l&#39;UI d&#39;édition de l&#39;email
     * Cette requête permet de récupérer une configuration de mail par identifiant.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEditorForTransactionalEmailUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionalEmailEditorDTO>;
    public getEditorForTransactionalEmailUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionalEmailEditorDTO>>;
    public getEditorForTransactionalEmailUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionalEmailEditorDTO>>;
    public getEditorForTransactionalEmailUsingGET(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getEditorForTransactionalEmailUsingGET.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling getEditorForTransactionalEmailUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getEditorForTransactionalEmailUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<TransactionalEmailEditorDTO>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/editor`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère l&#39;etl d&#39;une configuration de mail
     * Cette requête permet de récupérer une configuration de mail par identifiant.&lt;br&gt;En cas de succès, la réponse contient l&#39;etl de la configuration de mail en corps de la réponse et le code HTTP 200 (OK) est renvoyé.&lt;br&gt;En cas d&#39;erreur, et si l&#39;identifiant ne correspond à aucune configuration dans la base de données, le code d&#39;erreur 404 (Not Found) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEtlForTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<EtlConf>;
    public getEtlForTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EtlConf>>;
    public getEtlForTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EtlConf>>;
    public getEtlForTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getEtlForTransactionalEmailUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getEtlForTransactionalEmailUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EtlConf>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/etl`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère une configuration de mail par identifiant
     * Cette requête permet de récupérer une configuration de mail par identifiant.&lt;br&gt;En cas de succès, la réponse contient la configuration de mail en corps de la réponse et le code HTTP 200 (OK) est renvoyé.&lt;br&gt;En cas d&#39;erreur, et si l&#39;identifiant ne correspond à aucune configuration dans la base de données, le code d&#39;erreur 404 (Not Found) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionalEmailConfDTO>;
    public getTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionalEmailConfDTO>>;
    public getTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionalEmailConfDTO>>;
    public getTransactionalEmailUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTransactionalEmailUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTransactionalEmailUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TransactionalEmailConfDTO>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Génère le HTML du mail
     * Cette requête permet de générer le HTML du mail.
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param data data
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public previewTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, id: string, observe?: 'body', reportProgress?: boolean): Observable<GetSmtpTemplateOverviewDTO>;
    public previewTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSmtpTemplateOverviewDTO>>;
    public previewTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSmtpTemplateOverviewDTO>>;
    public previewTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling previewTransactionalEmailUsingPOST.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling previewTransactionalEmailUsingPOST.');
        }

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling previewTransactionalEmailUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling previewTransactionalEmailUsingPOST.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (X_LANG !== undefined && X_LANG !== null) {
            queryParameters = queryParameters.set('X-LANG', <any>X_LANG);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<GetSmtpTemplateOverviewDTO>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/preview`,
            data,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Envoi un mail de test.
     *
     * @param xDataStoreID X-DataStoreID
     * @param X_LANG X-LANG
     * @param data data
     * @param email email
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public testEmailTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, email: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public testEmailTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, email: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public testEmailTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, email: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public testEmailTransactionalEmailUsingPOST(xDataStoreID: string, X_LANG: string, data: any, email: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling testEmailTransactionalEmailUsingPOST.');
        }

        if (X_LANG === null || X_LANG === undefined) {
            throw new Error('Required parameter X_LANG was null or undefined when calling testEmailTransactionalEmailUsingPOST.');
        }

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling testEmailTransactionalEmailUsingPOST.');
        }

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling testEmailTransactionalEmailUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling testEmailTransactionalEmailUsingPOST.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (X_LANG !== undefined && X_LANG !== null) {
            queryParameters = queryParameters.set('X-LANG', <any>X_LANG);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/transactional-email/${encodeURIComponent(String(id))}/test-email`,
            data,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifie une configuration de mail
     * Cette requête permet de modifier une configuration de mail.&lt;br&gt;Les données de la configuration de mail sont envoyées dans le corps de la requête.&lt;br&gt;En cas de succès, la réponse contient le DTO de la configuration de mail en corps de la réponse et le code HTTP 200 (OK) est renvoyé.&lt;br&gt;En cas d&#39;erreur, et si le DTO est invalide, le code d&#39;erreur 400 (Bad Request) est renvoyé.&lt;br&gt;En cas d&#39;erreur, et si la modification de la configuration de mail échoue, le code d&#39;erreur 500 (Internal Server Error) est renvoyé.&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore/tenant.
     * @param xDataStoreID X-DataStoreID
     * @param transactionalEmailDTO transactionalEmailDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTransactionalEmailUsingPUT(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe?: 'body', reportProgress?: boolean): Observable<TransactionalEmailConfDTO>;
    public updateTransactionalEmailUsingPUT(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionalEmailConfDTO>>;
    public updateTransactionalEmailUsingPUT(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionalEmailConfDTO>>;
    public updateTransactionalEmailUsingPUT(xDataStoreID: string, transactionalEmailDTO: TransactionalEmailConfDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateTransactionalEmailUsingPUT.');
        }

        if (transactionalEmailDTO === null || transactionalEmailDTO === undefined) {
            throw new Error('Required parameter transactionalEmailDTO was null or undefined when calling updateTransactionalEmailUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<TransactionalEmailConfDTO>(`${this.basePath}/api/transactional-email`,
            transactionalEmailDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter un email transactionnel au format JSON
     * Cette requête permet d'exporter un email transactionnel au format JSON. (code 200)
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportTransactionalEmailJson(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportTransactionalEmailJson(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportTransactionalEmailJson(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportTransactionalEmailJson(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportTransactionalEmailJson.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportTransactionalEmailJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/transactional-email/export/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs emails transactionnels au format ZIP
     * Cette requête permet d'exporter plusieurs emails transactionnels dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportTransactionalEmailsZip(xDataStoreID: string, ids: string[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportTransactionalEmailsZip(xDataStoreID: string, ids: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportTransactionalEmailsZip(xDataStoreID: string, ids: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportTransactionalEmailsZip(xDataStoreID: string, ids: string[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportTransactionalEmailsZip.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling exportTransactionalEmailsZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/transactional-email/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer un email transactionnel depuis JSON
     * Cette requête permet d'importer un email transactionnel depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importTransactionalEmailJson(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionalEmailConfDTO>;
    public importTransactionalEmailJson(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionalEmailConfDTO>>;
    public importTransactionalEmailJson(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionalEmailConfDTO>>;
    public importTransactionalEmailJson(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importTransactionalEmailJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importTransactionalEmailJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<TransactionalEmailConfDTO>('post',`${this.basePath}/api/transactional-email/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs emails transactionnels depuis ZIP
     * Cette requête permet d'importer plusieurs emails transactionnels depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importTransactionalEmailsZip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<TransactionalEmailConfDTO>>;
    public importTransactionalEmailsZip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransactionalEmailConfDTO>>>;
    public importTransactionalEmailsZip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransactionalEmailConfDTO>>>;
    public importTransactionalEmailsZip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importTransactionalEmailsZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importTransactionalEmailsZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<TransactionalEmailConfDTO>>('post',`${this.basePath}/api/transactional-email/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
